export default __webpack_public_path__ + "static/media/Tier_3.e161be72.svg";